<template>
<div class="Ams-slution-page">
   <div class="content" v-if="$route.params.id==1">
    <h2>无源RFID资产管理</h2><div><div class="text-content-h5">    <div class="text-item">       <h4>面临问题</h4>      <ul class="text-ul">        <li>1、管理混乱、账实不相符合</li>        <li>2、管理流程难以实时跟踪</li>        <li>3、资产状态、位置无法及时获悉</li>        <li>4、手工盘点繁琐易错、效率低下</li>      </ul>    </div>    <div class="text-item">      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/6497298943392984.jpg" alt="" class="">        <p class="img-text">（网络架构）</p>      </div>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/9759238553271565.png" alt="">        <p class="img-text">（功能介绍）</p>      </div>    </div>    <div class="text-item">       <h4>主要功能</h4>    </div>    <div class="text-item text-item-grey">      <ul class="text-ul">        <li><b>资产全生命周期：</b>主要包括资产的采购、验收入库、领用退库、借用归还、调拨、维修、盘点、折旧、处置等功能</li>        <li><b>资产标签打印：</b>批量打印资产标签，支持多种不干胶标签及多种RFID标签，可定义标签内容及二维码内容</li>        <li><b>资产盘点：</b>支持多种盘点方式，手机扫码盘点、RFID盘点、RFID红外扫码盘点、远程自动盘点、离线盘点、手动盘点等</li>        <li><b>资产监控：</b>可监控资产进出并在资产异常进出时及时报警，包括资产进出及报警记录查询及监控设备维护</li>        <li><b>工作流审批：</b>灵活、高效、可自定义的审批流程，实现日常业务管理的自动化、智能化和整合化</li>        <li><b>权限设置：</b>支持用户为每个岗位定义模块及业务的操作权限和数据查阅权限</li>        <li><b>智能报表：</b>自定义行、列分组项及统计项，快速搭建各类报表</li>      </ul>    </div>    <div class="text-item">      <h4>功能特点</h4>      <div>        <h5>RFID标签打印</h5>        <p>RFID电子标签内涵芯片和天线，利用RFID标签打印机在可视化打印的同时将数据内容写入芯片中存取，实现资产与RFID标签的批量快速绑定。</p>      </div>      <ul class="two-img">        <li>          <img src="https://hz.chenksoft.com:443//upload/image/8290209365441934.jpeg" alt="">          <p class="img-text">（RFID标签打印机）</p>        </li>        <li>          <img src="https://hz.chenksoft.com:443//upload/image/9211019843465773.jpg" alt="">          <p class="img-text">（系统RFID标签打印）</p>        </li>      </ul>      <div>        <h5>RFID手持机盘点</h5>        <p>RFID手持机具有远距离快速识别、高可靠性等特点，可支持在线及离线两种模式下的一键盘点及红外扫码盘点，快速获得准确的盘点盈亏数据。还支持资产查询、数据分析等功能。</p>      </div>      <ul class="two-img">        <li>          <img src="https://hz.chenksoft.com:443//upload/image/6785977988255494.jpg" alt="">          <p class="img-text">（RFID手持机）</p>        </li>        <li>          <img src="https://hz.chenksoft.com:443//upload/image/6511888331191762.jpg" alt="盘点APP2"><span class="img-text">（App系统）        </span></li>      </ul>    </div>  </div><p><br></p></div>
   </div>
   <div class="content" v-else-if="$route.params.id==2">
    <h2>有源RFID资产管理</h2><div><div class="text-content-h5">    <div class="text-item">      <h4>面临的问题</h4>      <p><b>1、盘点效率及准确率不够高</b></p>      <p>固定资产数量庞大，位置分散，扫码盘点效率不够高，无源RFID盘点高效但是有一定误差率，在标签被遮挡及距离稍远时会读取不到。</p>      <p><b>2、资产位置变动不能及时发现</b></p>      <p>资产管理员所管理的资产数量多，位置不集中，导致资产发生位置异常变动时不能及时被发现，等发现时已无从追责，易引起纠纷。</p>    </div>    <div class="text-item">      <h4>系统架构</h4>    </div>    <div class="text-item">      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/07719437173171517.jpg" alt="有源标签盘点" style="max-width: 100%;" class="clicked">      </div>    </div>     <div class="text-item text-item-grey">      <ul class="text-ul">        <li><b>RFID电子标签：</b>挂或粘贴于资产表面</li>        <li><b>RFID识别设备：</b>主要悬挂或部署于出入通道，对有源电子标签进行识读。</li>      </ul>    </div>    <div class="text-item">     <h4>方案特点</h4>      <div>        <h5>1、自动化盘点</h5>        <p>有源RFID资产管理方案可实现自动化盘点，有源RFID标签通过RFID识别设备实时将数据上传至服务器，管理员只需创建盘点任务，服务器自动将接收到的数据与盘点任务进行匹配，盘点过程可实现完全自动化。</p>      </div>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/41589415342863645.png" alt="">      </div>      <div>        <h5>2、资产监控报警</h5>        <p>R依靠有源RFID标签的实时数据采集功能以及各出入通道部署的RFID 阅读器，可实时将采集到的数据上报至服务器，从而实现对资产的未授权移动进行实时报警。</p>      </div>     <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/11250458851489964.png" alt="">      </div>    </div>  </div><p><br></p></div>
   </div>
   <div class="content" v-else-if="$route.params.id==3">
    <h2>移动APP资产管理</h2><div><div class="text-content-h5">    <div class="text-item">      <h4>主要功能</h4>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/3723973284711737.jpg" alt="资产网站-主要功能_画板 1" style="max-width: 100%;">      </div>    </div>    <div class="text-item">     <h4>功能特点</h4>      <div>        <h5>1、APP移动盘点</h5>        <p>支持手机扫码盘点，全员轻松参与。也支持PDA红外扫码盘点及RFID快速盘点。多端数据互通，提升盘点效率。</p>      </div>      <ul class="two-img">        <li><img src="https://hz.chenksoft.com//upload/image/7649120638000018.png" alt=""></li>        <li><img src="https://hz.chenksoft.com//upload/image/21754597217765226.jpeg" alt=""></li>      </ul>      <div>        <h5>2、扫码报修</h5>        <p>对自己名下使用的资产，使用人可通过手机扫码自助报修，省去繁琐的报修流程，减轻资产管理员的压力。</p>      </div>      <ul class="two-img">        <li><img src="https://hz.chenksoft.com//upload/image/7904163877422352.jpg" alt=""></li>      </ul>       <div>        <h5>3、便携蓝牙打印</h5>        <p>可以轻松通过手机连接便携蓝牙打印机，无需跑腿，随时随地灵活打印资产标签。</p>      </div>      <ul class="two-img">        <li><img src="https://hz.chenksoft.com//upload/image/262681172287315.png" alt=""></li>      </ul>    </div>  </div><p><br></p></div>
   </div>
   <div class="content" v-else-if="$route.params.id==4">
    <h2>高校资产管理</h2><div><div class="text-content-h5">    <div class="text-item">      <h4>存在的问题</h4>      <ul class="text-ul">        <li>1、高校资产管理制度不健全、家底不清</li>        <li>2、资产流失现象严重</li>        <li>3、资产重复购置，利用率低</li>        <li>4、资产购入后不能对资产动态实时掌控</li>        <li>5、无形资产管理欠缺</li>      </ul>    </div>    <div class="text-item">      <h4>全周期管理，一物一码，资产流失少</h4>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/6814018147673726.jpg" alt="画板 1@2x-100" style="max-width: 100%;">      </div>      <h4>定期盘点，盘活闲置资产，提高利用率</h4>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/5919366042468588.png" alt="">      </div>       <h4>固定资产、无形资产、在建工程、低值易耗品多口径管理</h4>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/37374410938559444.png" alt="">      </div>       <h4>通过接口对接，实现资产系统与其他业务系统数据互通</h4>      <div class="center-img">        <img src="https://hz.chenksoft.com:443//upload/image/9571628399415213.jpg" alt="画板 1@2x-100" style="max-width: 100%;">      </div>    </div>  </div><p><br></p></div>
   </div>
   <div class="content" v-else-if="$route.params.id==5">
     <h2>政府机关资产管理</h2><div><div class="text-content-h5">
      <div class="text-item">
          <h4>存在问题</h4>
          <ul class="text-ul">
            <li>1、缺乏完善的管理制度</li>
            <li>2、固定资产利用率低下</li>
            <li>3、管理信息化程度低</li>
          </ul>
        </div>
        <div class="text-item">
          <h4>主要功能</h4>
          <div class="center-img">
            <img src="https://hz.chenksoft.com:443//upload/image/9002759253926547.jpg" alt="">
          </div>
        </div>
        <div class="text-item">
          <h4>功能特点</h4>
          <ul class="text-ul">
            <li>1、初始台账快速整理、一键导入导出</li>
            <li>2、RFID盘点，定期清查资产</li>
            <li>3、内网部署、保障数据安全</li>
            <li>4、定制标签样式</li>
            <li>5、固定资产、无形资产、在建工程多口径管理</li>
          </ul>
        </div>
      </div></div>
   </div>
   <div class="content" v-else-if="$route.params.id==6">
      <h2>IT资产管理</h2><div><div class="text-content-h5">
      <div class="text-item">
        <h4>存在问题</h4>
        <ul class="text-ul">
          <li>1、IT设备和软件资产众多，运维人员少，管理难度大</li>
          <li>2、资产分布离散，不便于查找</li>
          <li>3、IT资产信息繁杂，信息变更无法及时更新</li>
        </ul>
      </div>
      <div class="text-item">
        <h4>功能介绍</h4>
        <ul class="text-item-grey text-ul text-indent0" style="margin-top: 1rem;">
          <li>
            <b>● 资产全生命周期：</b>主要包括资产的采购、验收入库、领用退库、借用归还、调拨、维修、盘点、折旧、处置等功能
          </li> 
          <li><b>● 资产标签打印：</b>批量打印资产标签，支持多种不干胶标签及多种RFID标签，可定义标签内容及二维码内容</li> 
          <li><b>● 资产盘点：</b>支持多种盘点方式，手机扫码盘点、RFID盘点、RFID红外扫码盘点、远程自动盘点、离线盘点、手动盘点等</li> 
          <li><b>● 资产监控：</b>可监控资产进出并在资产异常进出时及时报警，包括资产进出及报警记录查询及监控设备维护</li> 
          <li><b>● 耗材管理：</b>耗材库存管理及采购、领料、出入库</li> 
          <li><b>● 工作流审批：</b>灵活、高效、可自定义的审批流程，实现日常业务管理的自动化、智能化和整合化</li> 
          <li><b>● 权限设置：</b>支持用户为每个岗位定义模块及业务的操作权限和数据查阅权限</li> 
          <li><b>● 智能报表：</b>自定义行、列分组项及统计项，快速搭建各类报表</li> 
        </ul>   
      </div>
      <div class="text-item">
        <h4>特点</h4>
        <div>
          <h5>1、支持附属资产管理、可变更所属主资产</h5>
          <div class="center-img"><img src="https://hz.chenksoft.com:443//upload/image/6762907118132881.png" alt="搜索结果" style="max-width: 100%;"></div>
        </div>
        <div>
          <h5>2、耗材申领时可与资产关联</h5>
          <div class="center-img"><img src="https://hz.chenksoft.com:443//upload/image/8084047064538815.jpg" alt="搜索结果" style="max-width: 100%;"></div>
        </div>
      </div>
      </div></div>
   </div>
   <div v-else></div>
</div>
</template>
<script>
import TitleBar from './TitleBar.vue'


import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'AmsSolutionPage',
  components: {
    TitleBar
  },
  data() {
    return {
      routeId:'',
      activeName: 'tab0',
    }
  },
  methods: {
    
  },
  created: function(){
   
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.Ams-slution-page{
  background: #f8f8f8;
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 0.75rem;
  line-height: 1.5;
  .center-img{
    text-align: center;
  }
  .content{
    max-width: 1200px;
    background: #fff;
    margin: 0 auto;
    padding: 4rem 5rem;
    h2{
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 2rem;
    }
    .text-item{
      margin-bottom: 1rem;
      p+p{
        margin-top: .5rem;
      }
      h4{
        font-size: 0.9rem;
        padding-bottom: 0.3rem;
        padding-top: 1rem;
        border-bottom: 1px dashed #dedede;
        margin-bottom: 1rem;
      }
      h5{
        font-size: 0.8rem;
        padding-bottom: 0.3rem;
      }
      img{
        max-width: 100%;
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
      .img-text{
        text-align: center;
      }
      .two-img{
        text-align: center;
        margin-bottom: 2rem;
        li{
          width: 48%;
          margin-right: 1%;
          display: inline-block;
        }
      }
    }
    .text-content-h5{
      .text-item .text-ul li{
          margin: .5rem 0;
          list-style: none;
         line-height: 30px;
      }
      .text-item-grey{
        width: 100%;
        background: #f8f8f8;
        padding: 1rem 1.5rem;
      }
    }
  }
 
}
</style>